// NGRX -
import { createSelector } from '@ngrx/store';
import { StoreState } from '../store.reducers';

export const selectStoreState = (state: any) => <StoreState>state.store;

export const currentStore = createSelector(selectStoreState, store => store?.selected);

export const currentStoresList = createSelector(selectStoreState, store => store.list);

export const currentStoreLoading = createSelector(selectStoreState, store => store.loading);


